import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getAirportZipCodeApi } from './getAirportZipCode.api'
import getAirportZipCodeInitialState from './getAirportZipCode.initialState'
import { GetAirportZipCodeErrorResponse, GetAirportZipCodeRequestPayload } from './getAirportZipCode.types'

export const getAirportZipCode = createAsyncThunk(
  urls.flights.getAirportZipCode,
  async (payload: GetAirportZipCodeRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getAirportZipCodeApi(request)

      onSuccess?.(response)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getAirportZipCodeSlice = createSlice({
  name: urls.flights.getAirportZipCode,
  initialState: getAirportZipCodeInitialState,
  reducers: {
    clearAirportZipCodeSuccess: (state) => {
      state.success = null
      state.error = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAirportZipCode.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getAirportZipCode.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getAirportZipCode.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetAirportZipCodeErrorResponse
        state.success = null
      })
  }
})

export const { actions: getAirportZipCodeActions, reducer: getAirportZipCodeReducer } = getAirportZipCodeSlice
export const { clearAirportZipCodeSuccess } = getAirportZipCodeActions
export default getAirportZipCodeSlice.reducer
